import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import Tag from '../tag';
export default function PickerTag(props) {
  return /*#__PURE__*/React.createElement(Tag, _extends({
    color: "blue"
  }, props));
}